import initialState from '../initialState.js';
import {
    SHOW_NOTIFICATION,
    HIDE_NOTIFICATION,
    UPDATE_LAST_UPDATED_TIMESTAMP
} from '../../actions/types/notifier';

export default (state = initialState.notifier, action) => {
    switch (action.type) {
        case SHOW_NOTIFICATION: {
            return {
                ...state,
                showing: true,
                link: action.link || null,
                verbiage: action.verbiage || 'Something failed, please try again.',
                type: action.notifierType || 'error'
            };
        }

        case HIDE_NOTIFICATION: {
            return {
                ...state,
                showing: false
            };
        }

        case UPDATE_LAST_UPDATED_TIMESTAMP: {
            return {
                ...state,
                lastUpdated: new Date()
            };
        }

        default:
            return state;
    }
};